import React from "react";
import AnalyticsContent from "./AnalyticsContent";

const Analytics = (props) => {
    const { formData, formIndex, source, formname, analyticsConfig } = props;
    let data = formData[formIndex];
    let formId = data[formname + '_id'];
    let totalCount = data['TotalCount'] === "" || data['TotalCount'] === null ? 0 : data['TotalCount'];
    let sentCount = data['sentCount'] === "" || data['sentCount'] === null ? 0 : data['sentCount'];
    let deliveredCount = data['deliveredCount'] === "" || data['deliveredCount'] === null ? 0 : data['deliveredCount'];
    let ReadCount = data['ReadCount'] === "" || data['ReadCount'] === null ? 0 : data['ReadCount'];
    let repliedCount = data['RepliedCount'] === "" || data['RepliedCount'] === null ? 0 : data['RepliedCount'];
    let viewLink = "#/deliverylog/" + source + "/" + formId;
    return (
        <AnalyticsContent totalCount={totalCount} sentCount={sentCount} deliveredCount={deliveredCount} ReadCount={ReadCount} repliedCount={repliedCount} viewLink={viewLink} formId={formId} source={source} analyticsConfig={analyticsConfig} />
    )
}


export default Analytics;
